<template>
<BootstrapDialog title="直播播放地址" ref="dialog" size="lg" @afterClose="afterClose()">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
		    <div class="row">
		        <div class="col-sm-8 col-sm-offset-2">
		            <h3 class="m-t-none m-b font-thin"><i class="fa fa-play-circle-o" aria-hidden="true"></i>文档流-播放地址</h3>
		            <h5>RTMP播放地址</h5>
					<div class="well" v-html="zb.rtmpdza" style="white-space:normal; word-break:break-all;"></div>
		            <h5>FLV播放地址</h5>
					<div class="well" v-html="zb.flvdza" style="white-space:normal; word-break:break-all;"></div>
		            <h5>HLS播放地址</h5>
					<div class="well" v-html="zb.hlsdza" style="white-space:normal; word-break:break-all;"></div>
		             <h3 class="m-t-none m-b font-thin"><i class="fa fa-play-circle-o" aria-hidden="true"></i>教师流-播放地址</h3>
		            <h5>RTMP播放地址</h5>
					<div class="well" v-html="zb.rtmpdzb" style="white-space:normal; word-break:break-all;"></div>
		            <h5>FLV播放地址</h5>
					<div class="well" v-html="zb.flvdzb" style="white-space:normal; word-break:break-all;"></div>
		            <h5>HLS播放地址</h5>
					<div class="well" v-html="zb.hlsdzb" style="white-space:normal; word-break:break-all;"></div>
		        </div>
		    </div>
		</div>
	</template>
	<template v-slot:footer>
			<button class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>

    /**
     * 直播管理-直播列表-播放地址
     */
    export default {
        name:'ZhiboPlaySite',
        data:function(){
            return {
                zbId:'',
                zb:{}
            }
        },
        methods:{
			reset:function(){
				this.zbId = '';
				this.zb = {};
			},
			async open(params){
				this.zbId = params.zbId;
				let res =await this.$http.post('/htgl/biz/zypx/zb/getTlAndBlUrl',{id:this.zbId});
				if(res.data){
					this.zb = res.data || {};
				}
				this.$refs.dialog.open();
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			}
        }

    }
</script>